(function () {
  'use strict';

  const sections = document.querySelectorAll('.ol-press');
  if (!sections.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const INTERVAL_MS = 2000; // un pas toutes les 2s
  const ANIM_MS = 700;      // duree du mouvement (fluide)

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  sections.forEach(function (section) {
    const cards = section.querySelector('[data-ol-press-cards]');
    if (!cards || reduceMotion) return;

    // Boucle sans couture : clone de la sequence, on reboucle a la moitie.
    const originals = Array.from(cards.children);
    if (!originals.length) return;
    originals.forEach(function (node) {
      const clone = node.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      cards.appendChild(clone);
    });

    let loopDistance = 0;
    function measure() {
      const firstClone = cards.children[originals.length];
      loopDistance = firstClone ? firstClone.offsetLeft - cards.children[0].offsetLeft : 0;
    }
    measure();
    window.addEventListener('resize', measure);

    let pos = 0;
    let animating = false;

    function metrics() {
      const card = cards.querySelector('.ol-press__card');
      const cardWidth = card ? card.getBoundingClientRect().width : 0;
      const gap = parseFloat(getComputedStyle(cards).gap) || 24;
      return cardWidth + gap;
    }

    // Animation fluide d'un pas (une carte), avec easing.
    function step() {
      if (animating) return;
      const from = pos;
      const to = from + metrics();
      const start = performance.now();
      animating = true;

      function frame(now) {
        const t = Math.min(1, (now - start) / ANIM_MS);
        pos = from + (to - from) * easeInOutCubic(t);
        cards.scrollLeft = pos;
        if (t < 1) {
          requestAnimationFrame(frame);
        } else {
          pos = to;
          // Reboucle invisible (clones identiques aux originaux).
          if (loopDistance && pos >= loopDistance) {
            pos -= loopDistance;
            cards.scrollLeft = pos;
          }
          animating = false;
        }
      }
      requestAnimationFrame(frame);
    }

    let timer = setInterval(step, INTERVAL_MS);
    function pause() { clearInterval(timer); timer = null; }
    function resume() { if (!timer) timer = setInterval(step, INTERVAL_MS); }

    cards.addEventListener('mouseenter', pause);
    cards.addEventListener('mouseleave', resume);
    cards.addEventListener('focusin', pause);
    cards.addEventListener('focusout', resume);
  });
})();
